const initialState = {
  loading: false,
  error: false,
  message: "",
  rawData: [],
  data: {},
  dataChart: {
    citas: { loading: false, data: null },
    ordenes: { loading: false, data: null },
    coti: { loading: false, data: null },
    citasf: { loading: false, data: null },
  },
  select: {},
  year: 0,
  month: 0,
  type: 0,
  typeData: 1,
  vsMorD: 0,
  selectStatusChart: JSON.parse(
    localStorage.getItem("selectStatusChartV3")
  ) || {
    citas: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    ordenes: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    coti: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
    citasf: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_DA_SERVICIOS":
      return { ...state, error: false, loading: action.payload };
    case "READY_DATA_DA_SERVICIOS":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        rawData: action.payload.rawData,
      };
    case "READY_SELECT_DA_SERVICIOS":
      return { ...state, loading: false, error: false, select: action.payload };
    case "LOADING_CHART_DA_SERVICIOS":
      return {
        ...state,
        dataChart: {
          ...state.dataChart,
          [action.payload.type]: {
            ...state.dataChart[action.payload.type],
            data: null,
            loading: action.payload.loading,
          },
        },
      };
    case "READY_DATA_CHART_DA_SERVICIOS":
      return {
        ...state,
        dataChart: {
          ...state.dataChart,
          [action.payload.type]: {
            ...state.dataChart[action.payload.type],
            data: action.payload.data,
            loading: false,
          },
        },
      };
    case "CHANGE_SELECT_CHART_DA_SERVICIOS":
      return {
        ...state,
        selectStatusChart: {
          ...state.selectStatusChart,
          [action.payload.type]: {
            ...state.selectStatusChart[action.payload.type],
            [action.payload.select]: action.payload.value,
          },
        },
      };
    case "CHANGE_TYPE_DA_SERVICIOS":
      return {
        ...state,
        loading: false,
        error: false,
        type: action.payload.type,
        vsMorD: action.payload.vsMorD,
        data: action.payload.data,
      };
    case "CHANGE_TYPE_DATA_DA_SERVICIOS":
      return {
        ...state,
        loading: false,
        error: false,
        typeData: action.payload,
      };
    case "ERROR_DA_SERVICIOS":
      return { ...state, loading: false, error: true, message: action.payload };
    case "CHANGE_DATE_DA_SERVICIOS":
      return {
        ...state,
        year: action.payload.year,
        month: action.payload.month,
        data: {},
        rawData: [],
        type: 0,
        vsMorD: 0,
      };
    default:
  }
  return state;
};
